import { render, staticRenderFns } from "./Froot_Wheel_Triggers.vue?vue&type=template&id=05d1caa6"
import script from "./Froot_Wheel_Triggers.vue?vue&type=script&lang=js"
export * from "./Froot_Wheel_Triggers.vue?vue&type=script&lang=js"
import style0 from "./Froot_Wheel_Triggers.vue?vue&type=style&index=0&id=05d1caa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports